import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function PUT(request: NextRequest) {
  try {
    const body = await request.json();
    const { trainerId, status } = body;
    
    console.log(`🏋️ Updating trainer ${trainerId} status to ${status}`);
    
    if (!trainerId || !status) {
      return NextResponse.json(
        { error: 'Trainer ID and status are required' },
        { status: 400 }
      );
    }
    
    if (!['approved', 'rejected'].includes(status)) {
      return NextResponse.json(
        { error: 'Status must be approved or rejected' },
        { status: 400 }
      );
    }
    
    const { pool } = await import('@/lib/db');
    await pool.execute(
      'UPDATE trainers SET status = ?, updated_at = NOW() WHERE id = ?',
      [status, trainerId]
    );
    
    console.log(`✅ Trainer ${trainerId} ${status} successfully`);
    
    return NextResponse.json({
      success: true,
      message: `Trainer ${status} successfully`
    });
  } catch (error) {
    console.error('❌ Error updating trainer:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to update trainer: ' + errorMessage },
      { status: 500 }
    );
  }
}
